import React from 'react';
import { Modal, Typography, Box, Button } from '@material-ui/core';

interface TokenInputModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (value: string) => void;
  lightMode: boolean;
  modalStyles: any;
}

const TokenInputModal: React.FC<TokenInputModalProps> = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  lightMode, 
  modalStyles 
}) => {
  const [inputValue, setInputValue] = React.useState('');

  const handleConfirm = () => {
    if (inputValue.trim()) {
      onConfirm(inputValue);
      setInputValue('');
    }
  };

  const handleCancel = () => {
    setInputValue('');
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={handleCancel}>
      <Box style={{
        width: "450px",
        maxWidth: "90vw",
        maxHeight: "100%",
        position: "fixed" as const,
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        backgroundColor: lightMode ? "white" : "#333",
        borderRadius: "8px",
        border: lightMode ? "" : "1px solid #737171",
        padding: "0"
      }}>
        <div className="ivr-header" style={{ ...modalStyles.header, justifyContent: "start" }}>
          <Typography variant="h6">Enter Minutes Per Call</Typography>
        </div>
        <div style={{ padding: "20px", display: "flex", flexDirection: "column", gap: "15px" }}>
          <Typography style={{ color: lightMode ? "#333" : "#fff" }}>
            How many minutes do you estimate each call takes on average?
          </Typography>
          
          <div style={{
            backgroundColor: lightMode ? "#f8f9fa" : "#2a2a2a",
            padding: "12px",
            borderRadius: "6px",
            border: lightMode ? "1px solid #e9ecef" : "1px solid #444"
          }}>
            <Typography variant="caption" style={{ 
              color: lightMode ? "#28a745" : "#4caf50", 
              fontWeight: "bold",
              display: "block",
              marginBottom: "4px"
            }}>
              💡 Example:
            </Typography>
            <Typography variant="caption" style={{ 
              color: lightMode ? "#666" : "#ccc",
              fontFamily: "monospace"
            }}>
              If you enter &quot;5&quot;, and there are 3 people in queue:<br/>
              System will calculate: 5 minutes × 3 people = 15 minutes wait time
            </Typography>
          </div>
          
          <input
            type="number"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            placeholder="Enter minutes (e.g., 5)"
            style={{
              width: "100%",
              padding: "12px",
              border: lightMode ? "1px solid #ccc" : "1px solid #555",
              borderRadius: "6px",
              backgroundColor: lightMode ? "white" : "#444",
              color: lightMode ? "black" : "white",
              fontSize: "16px",
              boxSizing: "border-box"
            }}
            min="1"
            max="60"
          />
          
          <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <Button variant="outlined" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleConfirm}
              disabled={!inputValue.trim()}
            >
              Insert Token
            </Button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default TokenInputModal;